    // Transform selected slide function
  export function transformSelectedSlide(selectedSlide) {
    if (
      !selectedSlide ||
      !selectedSlide.slideIds ||
      !selectedSlide.signedUrls
    ) {
      return selectedSlide;
    }

    const urlMap = Object.fromEntries(
      selectedSlide.signedUrls.map((url) => [url.pageId, url])
    );

    const slideNumMap = Object.fromEntries(
      selectedSlide.slidenums?.map((num, index) => [
        selectedSlide.slideIds[index],
        num,
      ]) || []
    );

    return {
      ...selectedSlide,
      slideIds: [...selectedSlide.slideIds], // Keep original order
      slidenums: selectedSlide.slideIds
        .map((id) => slideNumMap[id])
        .filter(Boolean),
      signedUrls: selectedSlide.slideIds
        .map((id) => urlMap[id])
        .filter(Boolean),
    };
  }
  
  export const createPageIdToSlideMap = (slideData) => {
    const pageIdToSlideMap = {};
    if (
      slideData?.slideIds &&
      slideData?.slidenums &&
      slideData?.signedUrls
    ) {
      slideData.slideIds.forEach((pageId, index) => {
        pageIdToSlideMap[pageId] = {
          slideLabel: slideData.slidenums[index],
          signedUrl:
            slideData.signedUrls.find((url) => url.pageId === pageId)
              ?.signedUrl || "",
        };
      });
    }
    return pageIdToSlideMap;
  };

export const transformElementRationale = (modules, pageIdToSlideMap) => {
    if (!Array.isArray(modules)) return modules;

    return modules.map((module) => {
        const updatedModule = { ...module };

        // Helper function to get slide label from pageId
        const getSlideLabelFromPageId = (pageId) => {
            const slideLabel = pageIdToSlideMap[pageId]?.slideLabel;
            if (!slideLabel) return null;
            
            const cleanLabel = slideLabel
                .replace(/slide_/i, "")
                .replace(/slide/i, "Slide");
            return `Slide_${cleanLabel}`;
        };

        // Helper function to replace page IDs in text with slide labels
        const replacePageIdsInText = (text) => {
            if (!text) return text;
            
            let processedText = text;
            
            // Find all page IDs in the text (24-character hex strings)
            const pageIdPattern = /[0-9a-f]{24}/gi;
            const pageIds = text.match(pageIdPattern) || [];
            
            // Replace each pageId with slide label
            pageIds.forEach(pageId => {
                const slideLabel = getSlideLabelFromPageId(pageId);
                if (slideLabel) {
                    const regex = new RegExp(pageId, 'g');
                    processedText = processedText.replace(regex, slideLabel);
                }
            });
            
            return processedText;
        };

        // Helper function for element rationales
        const fixElementRationale = (item) => {
            if (!item?.elementRationale || !item?.sourcePageId) return item;

            const slideLabel = getSlideLabelFromPageId(item.sourcePageId);
            if (!slideLabel) return item;

            item.elementRationale = `This element comes from ${slideLabel}`;
            return item;
        };

        // 1. Transform moduleRationale
        if (updatedModule.moduleRationale) {
            updatedModule.moduleRationale = replacePageIdsInText(updatedModule.moduleRationale);
        }

        // 2. Transform sourceCombination
        if (Array.isArray(updatedModule.sourceCombination)) {
            updatedModule.sourceCombination = updatedModule.sourceCombination.map(pageId => {
                const slideLabel = getSlideLabelFromPageId(pageId);
                return slideLabel || pageId; // Return slide label if found, otherwise original pageId
            });
        }

        // 3. Apply to claims
        if (Array.isArray(updatedModule.claims)) {
            updatedModule.claims = updatedModule.claims.map((c) =>
                fixElementRationale({ ...c })
            );
        }

        // 4. Apply to reusable texts
        if (Array.isArray(updatedModule.reusableTexts)) {
            updatedModule.reusableTexts = updatedModule.reusableTexts.map((r) =>
                fixElementRationale({ ...r })
            );
        }

        // 5. Apply to components
        if (Array.isArray(updatedModule.components)) {
            updatedModule.components = updatedModule.components.map((c) =>
                fixElementRationale({ ...c })
            );
        }

        return updatedModule;
    });
};
